import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { FileTypeT3 } from '../../enums/user/file-type';
import { RiskControlFilter } from '../../models/riskControl/riskControl-filter';
import { debug } from 'console';
import { RiskControl } from '../../models/riskControl/riskControl';

@Injectable({
    providedIn: 'root',
  })
  export class riskControlService {

    constructor(private http: HttpClient) {}
deleteRiskControl(id: number): Observable<any> {
  
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/RiskControl/DeleteRiskControl?id=` + id, { headers });
  }
  GetRiskControlById(id: number): Observable<any> {
  
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`${environment.config.baseAppURL}/RiskControl/GetRiskControlById?id=` + id, { headers });
  }
  
  AddRiskControl(obj: RiskControl): Observable<any> {
  
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    // tslint:disable-next-line:max-line-length
    return this.http.post<any>(`${environment.config.baseAppURL}/RiskControl/AddRiskControl` , obj, { headers });
  }
    getRiskControl(filter: RiskControlFilter): Observable<any> {
      let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8')
      .set('request', JSON.stringify(filter));
        return this.http.get<any>(
          `${environment.config.baseAppURL}/RiskControl/GetRiskControlDetails`
          , { headers });
      }

      getAllDropdownList(): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('Content-Type', 'application/json; charset=utf-8');
        return this.http.get<any>(
          `${environment.config.baseAppURL}/RiskControl/DropdownListToAdd`,
          { headers }
        );
      }
   
}